export const FeatureCategoryTypeEnum = {
  SPORTS: 'Sports',
  METRICS: 'Metrics',
}
